module.exports = __webpack_public_path__ + "static/hellofresh_logo-cdd05e296b5d0f57c0892aecad2225b9.png";